import React, { Component } from 'react';
import Sidebar from '../Sidebar/Sidebar'
import './Collection.css'
import Loader from "react-loader-spinner";
import * as fileService from '../../services/fileService'
import { Link } from 'react-router-dom'
import pdfImage from '../Images/pdf.png'

class Files extends Component {
  state = {
    user:{},
    departmentId:"",
    fileTypes:[],
    message:"",
    count:"",
    status:"",
    files:[],
    sendMessage:'',
    isSending:false,
    toggleFiles:false,
    sendAttachmentForm:{
      fileToSend:{},
      receiverEmail:""

    },
    showKey:"",
    isInitiallyLoaded:true,
    fileName:"",
  }
  async componentDidMount (){
    let loggedInUser = localStorage.getItem('currentUser')
    let { id , departmentId} = this.props.match.params
    let response = await fileService.fetchFiles(id)
    let {files , fileTypes ,message ,count,status} = await response.data
    this.setState({files,fileTypes,departmentId,message,count,status})
    this.setState({user:loggedInUser})
    this.setState({isInitiallyLoaded:false})
    console.log(response.data)
  };
  toggleFileForPersonalFiles = (key) =>{
    let {fileTypes, toggleFiles} = this.state
    Object.keys(fileTypes).forEach(file=>{
     if(file === key){
       this.setState({showKey:file})
       this.setState({toggleFiles:!toggleFiles})
     }
    })

  }
  closeFileModalForPersonalItems = ()=>{
    let sendAttachmentForm = {...this.state.sendAttachmentForm}
    sendAttachmentForm.receiverEmail = ""
    let { sendFileButtonDisabled } = this.state
    this.setState({sendMessage:""})
    this.setState({sendFileModalForPersonalItems:false})
    this.setState({sendAttachmentForm})
    this.setState({sendFileButtonDisabled:true})
}
  submitSendAttachmentForm = async(e) => {
    e.preventDefault()
    this.setState({isSending:true})
    let { id } = this.state.sendAttachmentForm.fileToSend
    let sendAttachmentForm = {...this.state.sendAttachmentForm}
    const response = await fileService.fileSending(id ,this.state.sendAttachmentForm.receiverEmail)
    const sendMessage = response.message
    this.setState({sendMessage})
    this.setState({isSending:false})
    sendAttachmentForm.receiverEmail = ""
    this.setState({sendAttachmentForm})
}
  openFileModalForPersonalItems = (file) => {
    let sendAttachmentForm = {...this.state.sendAttachmentForm}
    sendAttachmentForm.fileToSend = file
    this.setState({sendAttachmentForm})
    this.setState({sendFileModalForPersonalItems:true})
}
handleChangeSenderEmail = (e) => {
  let sendAttachmentForm = {...this.state.sendAttachmentForm}
  let { sendFileButtonDisabled } = this.state
  sendAttachmentForm.receiverEmail = e.target.value
  if(sendAttachmentForm.receiverEmail.length > 0){
      this.setState({sendFileButtonDisabled:false})
  }else{
      this.setState({sendFileButtonDisabled:true})
  }
  this.setState({sendAttachmentForm})

  if(e.target.name === 'search') {
      this.setState({search : e.target.value})
  }
}
  render() {
    let {user ,departmentId ,message ,count,fileTypes ,toggleFiles ,showKey,files,status} = this.state
    return (
      this.state.isInitiallyLoaded ?
            <div className="flex justify-center items-center h-screen">
                <Loader type="Oval" className="align-middle" color="#F35D2D" height={100} width={100}/>
            </div>  :
             <div className="flex flex-row w-full">
                <div className=" p-4 bg-white  md:min-h-screen overflow-auto w-60 fixed">
                   <Sidebar user={user}/>
                </div>
                <div className="py-8 px-8 ml-60 upPart relative lg:max-h-48 w-full">
                   <div className="">
                      <div className="text-white flex">
                      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" /></svg>
                      <Link to={`/departments/${departmentId}`}>
                          <span className="ml-2">
                             Go back to Items Page
                          </span>
                        </Link>
                      </div>
                        <div className="mt-8">
                          <div class="flex">
                          <span className="text-2xl font-bold text-white">{message}</span>
                           <div className="ml-16 my-1 flex">
                            <div style={{ backgroundColor:"#ff944d" }} className="h-6 w-6 rounded-full text-white flex justify-center items-center">
                                  <svg className="w-4 h-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" /></svg>
                            </div>
                            <span className="text-white font-tight ml-2">{count} Documents</span>
                            </div>
                           <div className="ml-16 my-1 flex">
                            <div style={{ backgroundColor:"#ff944d" }} className="h-6 w-6 rounded-full text-white flex justify-center items-center">
                            <svg className="w-4 h-3" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                            </div>
                            <span className="text-white font-tight ml-2">Status: {status}</span>
                            </div>
                          </div>
                        </div>
                   </div>
                                     {
                                            this.state.sendFileModalForPersonalItems && (
                                                <div className=" w-screen fixed top-0 left-0 h-screen  z-10">
                                                    <div className="flex flex-col my-4 border-black py-4 px-10 bg-white absolute z-50 bottom-8 left-96 right-96 border-2">
                                                        <div className="flex flex-col my-4 text-wvrDarkPrimary">
                                                        <div className="flex">
                                                        <p className="font-bold text-left">Send File</p>
                                                        {
                                                            this.state.sendMessage && 
                                                            <p className="font-bold text-red-600 text-sm ml-8">{this.state.sendMessage}</p>
                                                        }
                                                        </div>
                                                            <form onSubmit={this.submitSendAttachmentForm}>
                                                            <div className="flex flex-row w-full gap-8 py-2">
                                                                    <div className="w-full flex flex-col">
                                                                        <label className="text-sm mb-1">
                                                                        Receiver Email
                                                                        </label>
                                                                        <input type="email" value={this.state.sendAttachmentForm.receiverEmail} onChange={this.handleChangeSenderEmail}  name="" id="" placeholder="Fill in the field" className="text-xs p-2 border-2 border-wvrPrimary rounded-md "/>
                                                                    </div>
                                                                </div>
        
                                                               <div className="flex flex-row w-full gap-8 py-2">
                                                                    <div className="w-full flex flex-col">
                                                                        <label className="text-sm mb-1">
                                                                        File To Send
                                                                        </label>
                                                                        <input readOnly type="text" value={this.state.sendAttachmentForm.fileToSend.label} name="" id="" placeholder="Fill in the field" className="text-xs p-2 border-2 border-wvrPrimary rounded-md "/>
                                                                        <input readOnly type="hidden" value={this.state.sendAttachmentForm.fileToSend.id} name="" id="" placeholder="Fill in the field" className="text-xs p-2 border-2 border-wvrPrimary rounded-md "/>
                                                                    </div>
                                                                </div>
        
                                                                <div className="flex flex-row gap-4 my-4">
                                                                    <button type="submit" disabled={this.state.isSending ? "disabled":""}  className={!this.state.isSending ?"bg-wvrblue text-white py-2 px-8 rounded-md":"bg-blue-300 text-white py-2 px-8 rounded-md"}>
                                                                        {this.state.isSending ? "Sending....":"Send Attachment"}
                                                                    </button>
                                                                    <button className="bg-wvrPrimary py-2 px-8 rounded-md" onClick={this.closeFileModalForPersonalItems}>cancel</button>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                    </div>
                                            )
                                        }
                   <div style={{ width:'96%' }} className="collectionPart mt-4 lg:mt-20 grid h-96  overflow-x-auto">
                    <form  className="bg-white p-8 rounded-md">
                         <span className="text-xl font-extrabold">Uploaded Documents</span>
                         <div className=" grid grid-cols-2  w-full gap-8 my-2 mb-4">
                           {
                             count !==0 ? 
                             Object.keys(fileTypes).map((key)=>{
                              return(
                               <div key={fileTypes[key].category} className="w-full flex flex-col">
                                 <div onClick={()=>this.toggleFileForPersonalFiles(fileTypes[key].category)} className="flex bg-gray-200 p-4 rounded-md cursor-pointer">
                                   <span className="text-lg  text-gray-600 font-semibold">{fileTypes[key].category}</span>
                                 </div>
                                 {
                                   (toggleFiles && showKey===fileTypes[key].category) && 
                                   <div className=" grid grid-cols-2  w-full gap-8 my-2 mb-4">
                                     {
                                         fileTypes[key].subCategory.map(sub=>{
                                           return(
                                             <div className="w-full flex flex-col">
                                                <label className="text-sm" >{sub.label}</label>
                                                 {                                                   
                                                   files.map(file=>{
                                                    if(file.label === sub.label){
                                                      return(
                                                        <>
                                                          <div className='flex mt-4'>
                                                          <a href={file.value} target="_blank" classname="mt-4">
                                                             <img src={pdfImage} width={40} alt="" />
                                                          </a>
                                                          <svg onClick={()=>this.openFileModalForPersonalItems(file)} className="w-5 h-5 ml-2 text-black-600 hover:text-blue-600 cursor-pointer" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" /></svg>
                                                          </div>
                                                        </>
                                                      )
                                                    }else{
                                                      return;
                                                    }
                                                   })
                                                 }
                                             </div>
                                           )
                                       })
                                     }                                     
                                   
                                 </div>
                                 }
                               </div>
                             )
                           }):""
                           }

                         </div>
                    </form>
                   </div>
                </div>
             </div>
    );
  }
}

export default Files
